import {client} from '../../apollo/apolloClient';
import {
  ADD_COMMENT,
  ADD_REPLY_TO_COMMENT,
  DELETE_COMMENT,
  DELETE_INNER_COMMENT,
  GET_COMMENT_REPLIES,
  GET_COMMENTS,
  GET_MORE_COMMENT_REPLIES,
  GET_MORE_COMMENTS,
  UPDATE_COMMENT,
  UPDATE_INNER_COMMENT,
} from '../../apollo/schema';
import message from 'antd/es/message';
import {
  CANCEL_REPLAY_TO_COMMENT,
  CANCEL_UPDATE_COMMENT,
  CHANGE_COMMENT_COUNT,
  CHANGE_COMMENT_FIELD,
  CHANGE_COMMENT_SUBMIT_STATUS,
  CHANGE_COMMENTS_DATA,
  CHANGE_MORE_COMMENTS_DATA,
  HANDLE_ADD_COMMENT,
  HANDLE_DELETE_COMMENT,
  HANDLE_GET_COMMENT_REPLIES,
  HANDLE_REPLY_TO_COMMENT,
  HANDLE_UPDATE_COMMENT,
  HANDLE_UPDATE_INNER_COMMENT,
  READY_TO_REPLY_COMMENT,
  READY_TO_UPDATE_COMMENT,
} from './types';

export function setCommentCount(count) {
  return {
    type: CHANGE_COMMENT_COUNT,
    payload: count === null || count === undefined ? 0 : count,
  };
}

export function getCommentsData(postId, productType) {
  return async (dispatch, getState) => {
    const pId = postId === '' ? getState().comments.postId : postId;
    const pType = productType === '' ? getState().comments.productType : productType;
    client.query({
      query: GET_COMMENTS,
      variables: {
        first: 6,
        postId: pId,
        productType: pType,
      },
    }).then(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        message.error('Error while retrieving comments');
      } else {
        dispatch({
          type: CHANGE_COMMENTS_DATA,
          payload: {
            postId: pId,
            productType: pType,
            commentsData: response.data.getBackTalks,
          },
        });
      }
    }).catch(() => message.error('Error while retrieving comments'));
  };
}

export function getMoreCommentsData() {
  return async (dispatch, getState) => {
    const {postId, productType, commentsData: {edges, pageInfo: {endCursor}}} = getState().comments;
    client.query({
      query: GET_MORE_COMMENTS,
      variables: {
        first: 6,
        after: endCursor,
        postId,
        productType,
      },
    }).then(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        message.error('Something went wrong. Please try again');
      } else {
        dispatch({
          type: CHANGE_MORE_COMMENTS_DATA,
          payload: {
            edges: edges.concat(response.data.getBackTalks.edges),
            pageInfo: response.data.getBackTalks.pageInfo,
          },
        });
      }
    });
  };
}

export function getCommentRepliesData(commentId) {
  return async (dispatch, getState) => {
    const {postId, productType} = getState().comments;
    client.query({
      query: GET_COMMENT_REPLIES,
      variables: {
        first: 5,
        postId,
        productType,
        replyToId: commentId,
      },
    }).then(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        message.error('Something went wrong. Please try again');
        dispatch({
          type: '',
          payload: '',
        });
      } else {
        const data = response.data.getReplyBackTalks;
        dispatch({
          type: HANDLE_GET_COMMENT_REPLIES,
          payload: {
            activeCommentId: commentId,
            edges: data.edges === null || data.edges.length === 0 ?
                [] :
                data.edges,
            pageInfo: data.pageInfo,
          },
        });
      }
    });
  };
}

export function getMoreCommentRepliesData(commentId) {
  return async (dispatch, getState) => {
    const {postId, productType, activeCommentRepliesData: {edges, pageInfo: {endCursor}}, latestInnerCommentId} = getState().comments;

    client.query({
      query: GET_MORE_COMMENT_REPLIES,
      variables: {
        first: 5,
        after: endCursor,
        postId,
        productType,
        replyToId: commentId,
      },
    }).then(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        message.error('Something went wrong. Please try again');
      } else {
        const data = response.data.getReplyBackTalks;
        const allEdges = data.edges === null || data.edges.length === 0 ?
            edges :
            edges.concat(data.edges);
        let filteredArray = [];
        let repeatCount = 0;

        if (latestInnerCommentId !== '') {
          for (let i = 0; allEdges.length > i; i++) {
            if (allEdges[i].node.backtalkId === latestInnerCommentId) {
              if (repeatCount > 0) {
                filteredArray.push(allEdges[i]);
              }
              repeatCount += 1;
            } else filteredArray.push(allEdges[i]);
          }
        } else filteredArray = allEdges;

        dispatch({
          type: HANDLE_GET_COMMENT_REPLIES,
          payload: {
            activeCommentId: commentId,
            edges: filteredArray,
            pageInfo: data.pageInfo,
          },
        });
      }
    });
  };
}

export function handleCommentFieldChange(value) {
  return {
    type: CHANGE_COMMENT_FIELD,
    payload: value,
  };
}

export function handleSubmitStatus(status) {
  return {
    type: CHANGE_COMMENT_SUBMIT_STATUS,
    payload: status,
  };
}

export function handleAddComment() {
  return async (dispatch, getState) => {
    const {postId, productType, commentText, commentsData: {edges}} = getState().comments;

    client.mutate({
      mutation: ADD_COMMENT,
      variables: {
        postId,
        productType,
        message: commentText,
      },
    }).then(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        message.error('Something went wrong. Please try again');
      } else {
        const comments = edges === null ?
            [response.data.addBackTalk] :
            edges.concat(response.data.addBackTalk);
        dispatch({
          type: HANDLE_ADD_COMMENT,
          payload: comments,
        });
      }
    });
  };
}

export function readyToReplyComment(commentId, innerCommentId, commentAuthor) {
  return async (dispatch, getState) => {
    const {isUserLoggedIn} = getState().util;
    if (isUserLoggedIn) {
      dispatch({
        type: READY_TO_REPLY_COMMENT,
        payload: {
          commentId,
          innerCommentId,
          commentAuthor,
        },
      });
    } else {
      message.warning('Please login to comment');
      dispatch({
        type: '',
        payload: '',
      });
    }
  };
}

export function cancelReplyToComment() {
  return {
    type: CANCEL_REPLAY_TO_COMMENT,
    payload: '',
  };
}

export function replyToComment() {
  return async (dispatch, getState) => {
    const {postId, productType, commentsData, activeCommentId, activeCommentRepliesData, replyingCommentData: {commentId}, commentText} = getState().comments;

    client.mutate({
      mutation: ADD_REPLY_TO_COMMENT,
      variables: {
        postId,
        productType,
        commentId,
        commentText,
      },
    }).then(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        message.error('Something went wrong. Please try again');
        dispatch({
          type: '',
          payload: '',
        });
      } else {
        let commentEdges = commentsData.edges;
        if (commentEdges !== null && commentEdges.length > 0) {
          for (let i = 0; commentEdges.length > i; i++) {
            if (commentEdges[i].node.backtalkId === commentId) {
              commentEdges[i].node.replyCount += 1;
            }
          }
        }

        let innerCommentEdges = [];
        if (activeCommentId !== '') {
          if (activeCommentId === commentId) {
            innerCommentEdges = activeCommentRepliesData.edges.concat(
                response.data.addReplyBackTalk);
          } else innerCommentEdges = [response.data.addReplyBackTalk];
        } else innerCommentEdges = [response.data.addReplyBackTalk];

        dispatch({
          type: HANDLE_REPLY_TO_COMMENT,
          payload: {
            commentEdges,
            activeCommentId: commentId,
            activeCommentRepliesData: {
              edges: innerCommentEdges,
              pageInfo: {
                endCursor: activeCommentRepliesData.pageInfo.endCursor,
                hasNextPage: activeCommentRepliesData.pageInfo.endCursor ===
                '' ? true : activeCommentRepliesData.pageInfo.hasNextPage,
              },
            },
            latestInnerCommentId: response.data.addReplyBackTalk.node.backtalkId,
          },
        });
      }
    });
  };
}

export function readyToUpdateComment(commentId, innerCommentId, commentText) {
  return {
    type: READY_TO_UPDATE_COMMENT,
    payload: {
      commentId,
      innerCommentId,
      commentText,
    },
  };
}

export function cancelUpdateComment() {
  return {
    type: CANCEL_UPDATE_COMMENT,
    payload: '',
  };
}

export function updateComment() {
  return async (dispatch, getState) => {
    handleSubmitStatus(true);
    const {commentsData, activeCommentRepliesData, updatingCommentData: {commentId, innerCommentId}, commentText} = getState().comments;
    const cId = innerCommentId === '' ? commentId : innerCommentId;

    client.mutate({
      mutation: innerCommentId === '' ? UPDATE_COMMENT : UPDATE_INNER_COMMENT,
      variables: {
        commentId: cId,
        commentText,
      },
    }).then(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        message.error('Something went wrong. Please try again');
        dispatch({
          type: '',
          payload: '',
        });
      } else if (innerCommentId === '') {
        let comments = commentsData.edges;
        for (let i = 0; comments.length > i; i++) {
          if (comments[i].node.backtalkId === commentId) {
            comments[i].node.message = commentText;
          }
        }
        dispatch({
          type: HANDLE_UPDATE_COMMENT,
          payload: comments,
        });
      } else {
        let innerComments = activeCommentRepliesData.edges;
        for (let i = 0; innerComments.length > i; i++) {
          if (innerComments[i].node.backtalkId === innerCommentId) {
            innerComments[i].node.message = commentText;
          }
        }
        dispatch({
          type: HANDLE_UPDATE_INNER_COMMENT,
          payload: innerComments,
        });
      }
    });
  };
}

export function deleteComment(commentId, innerCommentId) {
  return async (dispatch, getState) => {
    client.mutate({
      mutation: innerCommentId === '' ? DELETE_COMMENT : DELETE_INNER_COMMENT,
      variables: {
        commentId: innerCommentId === '' ? commentId : innerCommentId,
      },
    }).then(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        message.error('Something went wrong. Please try again');
        dispatch({
          type: '',
          payload: '',
        });
      } else if (innerCommentId === '') {
        let {edges} = getState().comments.commentsData;
        if (edges !== null && edges.length > 0) {
          for (let i = 0; edges.length > i; i++) {
            if (edges[i].node.backtalkId === commentId) {
              edges.splice(i, 1);
            }
          }
          dispatch({
            type: HANDLE_DELETE_COMMENT,
            payload: edges,
          });
        } else dispatch({
          type: '',
          payload: '',
        });
      } else {
        let {edges} = getState().comments.activeCommentRepliesData;
        if (edges !== null && edges.length > 0) {
          for (let i = 0; edges.length > i; i++) {
            if (edges[i].node.backtalkId === innerCommentId) {
              edges.splice(i, 1);
            }
          }
          dispatch({
            type: HANDLE_UPDATE_INNER_COMMENT,
            payload: edges,
          });
        } else dispatch({
          type: '',
          payload: '',
        });
      }
    });
  };
}
